import { render, staticRenderFns } from "./FamilyDetails.vue?vue&type=template&id=660fbd44"
import script from "./FamilyDetails.vue?vue&type=script&lang=js"
export * from "./FamilyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports